<script>
    import { tweened }          from 'svelte/motion'
    import { cubicOut }         from 'svelte/easing'
    import { fade, fly }        from 'svelte/transition'

    export let active = false

    const opacity = tweened(0, {
        duration: 800,
        easing: cubicOut
    })

    $: if(active) {
        opacity.set(.85) 
    } else {
        opacity.set(0)
    }
</script>
<style>
    .backdrop {
        z-index    : -1;
        position   : fixed;
        left       : 0;
        top        : 0;
        background : rgba(0,0,0, 0);
        width      : 100%;
        height     : 100%;
    }

    .backdrop.active {
        z-index: 1000;
    }
</style>
<div class="backdrop" class:active style="background: rgba(0,0,0, {$opacity});">
    {#if active}
        <div in:fly="{{ y: 20, duration: 500 }}" class="center-it">
            <slot></slot>
        </div>
    {/if}
</div>

